import 'product/form-xmas'
import 'product/ask'
import 'product/slider'
import 'global/sharing'
import 'product/bookmark'